/* eslint-disable no-restricted-syntax */
export const asyncNoop = async () => {};

const noop = () => {};

export default noop;
